import { FC } from "react";
import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { commitmentsColors } from "@/utils/constants/commitmentsColors";
import { AmountWithPercentageResponse } from "@/services/cloudchipr.api";
import { ResourceDetailsCoverageTabMetadataProgressTooltipItem } from "@/components/pages/common/resource-details/components/content/coverage-content/components/metadata/ResourceDetailsCoverageTabMetadataProgressTooltipItem";

interface ResourceDetailsCoverageTabMetadataProgressProps {
  sp?: AmountWithPercentageResponse;
  ri?: AmountWithPercentageResponse;
  onDemand?: AmountWithPercentageResponse;
  total?: AmountWithPercentageResponse;
  asChip?: boolean;
}

export const ResourceDetailsCoverageTabMetadataProgress: FC<
  ResourceDetailsCoverageTabMetadataProgressProps
> = ({ sp, ri, onDemand, total, asChip }) => {
  return (
    <Tooltip
      arrow
      title={
        <Stack p={1} spacing={1}>
          <ResourceDetailsCoverageTabMetadataProgressTooltipItem
            amount={sp?.amount}
            label="SP Coverage"
            percentage={sp?.percentage}
            color={commitmentsColors.sp}
          />
          <ResourceDetailsCoverageTabMetadataProgressTooltipItem
            amount={ri?.amount}
            label="RI Coverage"
            percentage={ri?.percentage}
            color={commitmentsColors.ri}
          />
          <ResourceDetailsCoverageTabMetadataProgressTooltipItem
            label="On-Demand"
            amount={onDemand?.amount}
            percentage={onDemand?.percentage}
            color={commitmentsColors.onDemand}
          />

          <ResourceDetailsCoverageTabMetadataProgressTooltipItem
            label="Coverage"
            amount={total?.amount}
            percentage={total?.percentage}
          />
        </Stack>
      }
      componentsProps={tooltipComponentProps}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        {asChip && (
          <Typography fontWeight="medium" variant="caption">
            {total?.percentage}%
          </Typography>
        )}

        <Stack
          direction="row"
          width="100%"
          height={10}
          borderRadius={2}
          overflow="hidden"
          bgcolor="grey.300"
        >
          <Box
            bgcolor={commitmentsColors.sp}
            flexBasis={`${sp?.percentage}%`}
          />
          <Box
            bgcolor={commitmentsColors.ri}
            flexBasis={`${ri?.percentage}%`}
          />
        </Stack>

        {!asChip && (
          <Typography fontWeight="medium" variant="caption">
            {total?.percentage}%
          </Typography>
        )}
      </Stack>
    </Tooltip>
  );
};

const tooltipComponentProps = {
  tooltip: {
    sx: {
      p: 0,
      boxShadow: 7,
      color: "text.primary",
      bgcolor: "background.paper",
      "& .MuiTooltip-arrow": { color: "background.paper" },
    },
  },
};
